import { Component } from 'react'
import LocalStorage from '~/components/OrdersPage/LocalStorage'
import Switch from '~/components/Switch/Switch'
import styles from '~/styles/ordersPage.datePickerColumn.module.css'
import types from '~/types/ordersPage.ts'

export default class DatePickerColumn extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}

	public constructor(props) {
		super(props)
		this._localStorage = new LocalStorage('datePickerColumn')
	}

	public render() {
		if (this.props.isShown) {
			const column = this.props.datePickerColumn
			return (
				<div
					className={styles.main}
				>
					<label>
						{this.props.t('Date Range Applies for')}
					</label>
					<div
						className={this.props.isDisabled ? styles.disabled : ''}
					>
						<div
							onClick={this._onClick.bind(this, 'orderCreated')}
						>
							<input
								type='radio'
								checked={column === 'orderCreated' || !column}
								onChange={() => {}}
							/>
							<div
								className={styles.label}
							>
								{this.props.t('orderCreated')}
							</div>
						</div>
						<div
							onClick={this._onClick.bind(this, 'lastOrderUpdate')}
						>
							<input
								type='radio'
								checked={column === 'lastOrderUpdate'}
								onChange={() => {}}
							/>
							<div
								className={styles.label}
							>
								{this.props.t('lastOrderUpdate')}
							</div>
						</div>
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	private _onClick(column) {
		if (!this.props.isDisabled) {
			this.props.setDatePickerColumn(column)
			if (this.props.isLocalStorageInUse) {
				this._localStorage.set(column)
			}
			if (this.props.onChange) {
				this.props.onChange(column)
			}
			this.props.onAction?.send({
		      action: 'Order list: date range column',
		      actionData: {
		        file: 'components/OrdersPage/DatePickerColumn.tsx',
		        column,
		      },
		    })
		}
	}
}
	